/**
 * @file Exposes `feather` object.
 */

import icons from '../dist/icons.json';
import toSvg from './to-svg';
import replace from './replace';

module.exports = { icons, toSvg, replace };



// WEBPACK FOOTER //
// ./src/index.js